import React from "react"

import { configuratorType, IConfiguratorCardProps } from "../../model"
import { LayoutIcon } from "./icons/layout"
import { SignatureIcon } from "./icons/signature"
import { ProfileIcon } from "./icons/profile"
import { SocialIcon } from "./icons/social"
import { ImageIcon } from "./icons/image"
import { DisclaimerIcon } from "./icons/disclaimer"
import { ChevronIcon } from "./icons/chevron"
import { PadlockIcon } from "./icons/padlock"

export const ConfiguratorCard = (props: IConfiguratorCardProps) => {
    const { id, active, disabled, children, changeCard } = props

    function renderTitle(id: configuratorType) {
        switch (id) {
            case "layout":
                return (
                    <span>
                        <LayoutIcon />
                        <span className="cnf-heading-text">Layout</span>
                    </span>
                )
            case "signature":
                return (
                    <span>
                        <SignatureIcon />
                        <span className="cnf-heading-text">Email signature</span>
                    </span>
                )
            case "profile":
                return (
                    <span>
                        <ProfileIcon />
                        <span className="cnf-heading-text">Profile</span>
                    </span>
                )
            case "social":
                return (
                    <span>
                        <SocialIcon />
                        <span className="cnf-heading-text">Social</span>
                    </span>
                )
            case "images":
                return (
                    <span>
                        <ImageIcon />
                        <span className="cnf-heading-text">Branding & Ads</span>
                    </span>
                )
            case "disclaimer":
                return (
                    <span>
                        <DisclaimerIcon />
                        <span className="cnf-heading-text">Disclaimer</span>
                    </span>
                )
            default:
                return null
        }
    }

    return (
        <div
            data-testid={id}
            id={id}
            className={`cnf-card ${active ? "active" : ""} ${disabled ? "disabled" : ""}`}
            onClick={() => {
                !active && !disabled && changeCard(id)
            }}
        >
            <div className="cnf-heading">
                {renderTitle(id)}
                {!disabled && (
                    <span className="chevron">
                        <ChevronIcon
                            onClick={() => {
                                if (active) {
                                    if (id === "signature") {
                                        changeCard("images")
                                    } else {
                                        changeCard("signature")
                                    }
                                }
                            }}
                        />
                    </span>
                )}
                {disabled && <PadlockIcon />}
            </div>
            {active && children && <div className="cnf-body">{children}</div>}
        </div>
    )
}

ConfiguratorCard.defaultProps = {
    disabled: false,
}
